import React from "react";
import styled from "styled-components";

interface Props {
  isOpen: boolean;
  setIsOpen: () => void;
}

const HamburgerMenuIcon: React.FC<Props> = ({ isOpen, setIsOpen }) => {
  return (
    <MenuContainer isOpen={isOpen} onClick={setIsOpen} id="nav-icon4">
      <Bar isOpen={isOpen} id="menu-first-bar" />
      <Bar isOpen={isOpen} id="menu-second-bar" />
      <Bar isOpen={isOpen} id="menu-third-bar" />
    </MenuContainer>
  );
};

export default HamburgerMenuIcon;

const Bar = styled.div<{ isOpen: boolean }>`
  position: absolute;
  height: 3px;
  width: 100%;
  background-color: ${({ theme, isOpen }) =>
    theme.colors.menu[isOpen ? "menuIcon" : "closedMenuIcon"]};
  opacity: 1;
  left: 0;
  transform: rotate(0deg);
  transition: 0.25s ease-in-out;
`;

const MenuContainer = styled.div<{ isOpen: boolean }>`
  width: 30px;
  height: 29px;
  position: relative;
  transform: rotate(0deg);
  transition: 0.5s ease-in-out;
  cursor: pointer;

  #menu-first-bar {
    top: 0px;
    transform-origin: left center;
  }

  #menu-second-bar {
    top: 12px;
    transform-origin: left center;
  }

  #menu-third-bar {
    top: 24px;
    transform-origin: left center;
  }

  ${({ isOpen }) =>
    isOpen &&
    `
      #menu-first-bar {
        transform: rotate(45deg);
        top: 2px;
        left: 4px;
      }

      #menu-second-bar {
        width: 0;
        opacity: 0;
      }

      #menu-third-bar {
        transform: rotate(-45deg);
        top: 23px;
        left: 4px;
      }
  `}
`;
